"use client";

import type * as React from "react";

// TODO: migrate to react aria alternative
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@ui/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const tooltipContentVariants = cva("", {
  variants: {
    variant: {
      default:
        "z-99 overflow-hidden animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 rounded-md border bg-default p-20 shadow-md",
      "dark-new":
        "tw-z-50 tw-bg-black tw-text-white tw-px-2 tw-py-2 tw-rounded-lg tw-type-sm tw-text-center tw-whitespace-nowrap",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const TooltipContent = ({
  className,
  sideOffset = 4,
  variant,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> &
  VariantProps<typeof tooltipContentVariants> & {
    ref?: React.Ref<React.ElementRef<typeof TooltipPrimitive.Content>>;
  }) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      className={cn(tooltipContentVariants({ variant }), className)}
      ref={ref}
      sideOffset={sideOffset}
      {...props}
    />
  </TooltipPrimitive.Portal>
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
